export const PERSONAL_PRICE = 39
export const BUSINESS_PRICE = 59
